import React from "react";
import "../../Stylesheets/Public/EmptyState.css"; // shared CSS



const EmptyState = ({
  title,
  subtitle,
  image,
  imageAlt = "empty",
  ctaLabel,
  onCta,
  disabled = false,
  icon = null,          // optional react-icon
  variant = "default",  // optional for tiny color tweaks later
}) => {
  return (
  <div className={`empty-state empty-state--${variant}`}>
    <div className="empty-state-card">
      {icon && <div className="empty-state-icon">{icon}</div>}
      <h2 className="empty-state-title">{title}</h2>
      {subtitle && <p className="empty-state-subtitle">{subtitle}</p>}
      {image && <img src={image} alt={imageAlt} className="empty-state-image" />}

      {ctaLabel && onCta && (
        <button
          className="empty-state-cta"
          onClick={onCta}
          disabled={disabled}
          type="button"
        >
          {ctaLabel}
        </button>
      )}
    </div>
  </div>
);

};

export default EmptyState;
